var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Descrição",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "descricao", $$v);
      },
      expression: "form.filters.descricao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Formação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.formacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "formacao", $$v);
      },
      expression: "form.filters.formacao"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarMaterial();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Incluir",
      "icon": "mdi-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterMaterial();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.formacao.formacao`,
      fn: function (_ref) {
        var _item$formacao;
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(((_item$formacao = item.formacao) === null || _item$formacao === void 0 ? void 0 : _item$formacao.formacao) || '-') + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Excluir",
            "color": "red",
            "icon": "mdi-delete",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.excluirMaterial(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Editar",
            "icon": "mdi-pencil",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterMaterial(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Baixar",
            "icon": "mdi-download",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.baixarMaterial(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarMaterial', {
    attrs: {
      "edit": _vm.dialogManterMaterial.edit,
      "visible": _vm.dialogManterMaterial.visible,
      "content": _vm.dialogManterMaterial.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterMaterial.close();
      },
      "onSave": function ($event) {
        return _vm.buscarMaterial();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }